import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionText } from '../../../components/SectionText'
import { TableContent, TableRow } from '../../../components/TableRow'

interface OrthopedicAndEmergencyProps {
    className?: string
}

export const OrthopedicAndEmergency: React.FC<OrthopedicAndEmergencyProps> = ({ className }) => {
    const { t } = useTranslation()

    const leftTableProps: TableContent = {
        classNameTr: 'flex',
        classNameTdLeft: 'flex bg-primary-green justify-center text-9xl font-bold text-white mr-6 pl-3 xs:pl-0 xs:text-7xl',
        textColumnLeft: '3',
        textColumnRight: (
            <SectionText
                className="text-white max-w-[500px]"
                title={t('orthopedicAndEmergency.pediatricOrthopedics')}
                hrLineColor="bg-primary-blue">
                <ul className="list-disc pl-5 mt-2">
                    <li>{t('orthopedicAndEmergency.conditions.posturesAndDeformities')}</li>
                    <li>{t('orthopedicAndEmergency.conditions.gaitAnomalies')}</li>
                    <li>{t('orthopedicAndEmergency.conditions.hipUltrasound')}</li>
                    <li>{t('orthopedicAndEmergency.conditions.scoliosisTreatment')}</li>
                </ul>
            </SectionText>
        ),
    }
    const rightTableProps: TableContent = {
        classNameTr: 'flex',
        classNameTdLeft: 'flex bg-white justify-center text-9xl font-bold text-primary-green mr-6 pl-3 xs:pl-0 xs:text-7xl',
        textColumnLeft: '4',
        textColumnRight: (
            <SectionText
                className="text-primary-green max-w-[600px]"
                title={t('orthopedicAndEmergency.emergencies.accidents')}
                hrLineColor="bg-primary-green">
                <ul className="list-disc pl-5 mt-2">
                    <li className="font-bold">{t('orthopedicAndEmergency.emergencies.kindergartenSchoolAccidents')}</li>
                    <ul className="list-disc pl-5">
                        <li>{t('orthopedicAndEmergency.emergencies.acuteInjuries')}</li>
                        <ul className="list-disc pl-5">
                            <li>{t('orthopedicAndEmergency.emergencies.injuries.wounds')}</li>
                            <li>{t('orthopedicAndEmergency.emergencies.injuries.bleeding')}</li>
                            <li>{t('orthopedicAndEmergency.emergencies.injuries.bruises')}</li>
                            <li>{t('orthopedicAndEmergency.emergencies.injuries.dislocations')}</li>
                        </ul>
                    </ul>
                    <li className="font-bold">{t('orthopedicAndEmergency.emergencies.accidentSurgery')}</li>
                    <ul className="list-disc pl-5">
                        <li>{t('orthopedicAndEmergency.emergencies.postEmergencyCare')}</li>
                        <li>{t('orthopedicAndEmergency.emergencies.materialRemoval')}</li>
                    </ul>
                </ul>
            </SectionText>
        ),
    }
    return (
        <div className={`${className} container flex min-h-[700px] sm:h-auto sm:flex-col sm:justify-between`}>
            <table className="flex bg-primary-green w-1/2 justify-center items-center sm:w-full sm:h-[500px] sm:px-5">
                <TableRow TableRowProps={leftTableProps} />
            </table>
            <table className="flex bg-white w-1/2 justify-center items-center sm:w-full sm:h-auto sm:min-h-[700px] sm:px-5 sm:py-10">
                <TableRow TableRowProps={rightTableProps} />
            </table>
        </div>
    )
}
